import React from "react";
import logo from "../pictures/logo-black-small.png";

const Logo = () => {
    return (
        <div className="logo">
            <img
                src={logo}
                alt="Logo tranport Rauwel, transport de marchandise, déménagement et location de véhicule avec chauffeur."
            />
        </div>
    );
};

export default Logo;
